export const GIT = "git";
export const EXOTIC = "exotic";
export const UNSTABLE = "unstable";
export const EXCLUDED = "excluded";
export const NOT_WANTED = "not-wanted";
